import { useContext, useCallback } from "react";
import { ToasterContext } from "./ToasterContext.js";
const TIMEOUT_BY_TYPE = {
  error: 1e4,
  warning: 8e3,
  info: 4e3,
  success: 4e3
};
const useShowToast = () => {
  const toasterContext = useContext(ToasterContext);
  if (!toasterContext) {
    throw new Error("Toaster context is not initialized");
  }
  const { showToast, dismissToast } = toasterContext;
  return useCallback(({ dismiss, ...toast }) => {
    const id = showToast(toast);
    if (dismiss !== void 0 && dismiss !== false) {
      setTimeout(() => {
        dismissToast(id);
      }, typeof dismiss !== "number" ? TIMEOUT_BY_TYPE[toast.type] : dismiss);
    }
  }, [dismissToast, showToast]);
};
export {
  useShowToast
};
//# sourceMappingURL=useShowToast.js.map
